import { createAction } from 'redux-actions';

const actions = {
  /**
   *  추천 검색 키워드 데이터 변경하기
   */
  SET_DATA: 'recommend/searchWord/SET_DATA',
  setData: createAction('recommend/searchWord/SET_DATA'),

  /**
   *  추천 검색 키워드 리스트 가져오기
   */
  GET_RECOMMEND_SEARCH_WORD_LIST_REQUEST: 'recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_LIST_REQUEST',
  GET_RECOMMEND_SEARCH_WORD_LIST_SUCCESS: 'recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_LIST_SUCCESS',
  getRecommendSearchWordList: createAction('recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_LIST_REQUEST'),

  /**
   *  추천 검색 키워드 상세 요청하기
   */
  GET_RECOMMEND_SEARCH_WORD_DETAIL_REQUEST: 'recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_DETAIL_REQUEST',
  GET_RECOMMEND_SEARCH_WORD_DETAIL_SUCCESS: 'recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_DETAIL_SUCCESS',
  getRecommendSearchWordDetail: createAction('recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_DETAIL_REQUEST'),

  /**
   *  추천 검색 키워드 복사하기 전 필요한 데이터 가져오기
   */
  PREPARE_COPY_RECOMMEND_SEARCH_WORD_REQUEST: 'recommend/searchWord/PREPARE_COPY_RECOMMEND_SEARCH_WORD_REQUEST',
  PREPARE_COPY_RECOMMEND_SEARCH_WORD_SUCCESS: 'recommend/searchWord/PREPARE_COPY_RECOMMEND_SEARCH_WORD_SUCCESS',
  prepareCopyRecommendSearchWord: createAction('recommend/searchWord/PREPARE_COPY_RECOMMEND_SEARCH_WORD_REQUEST'),

  /**
   *  추천 검색 키워드 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_CREATE_RECOMMEND_SEARCH_WORD_REQUEST: 'recommend/searchWord/PREPARE_CREATE_RECOMMEND_SEARCH_WORD_REQUEST',
  PREPARE_CREATE_RECOMMEND_SEARCH_WORD_SUCCESS: 'recommend/searchWord/PREPARE_CREATE_RECOMMEND_SEARCH_WORD_SUCCESS',
  prepareCreateRecommendSearchWord: createAction('recommend/searchWord/PREPARE_CREATE_RECOMMEND_SEARCH_WORD_REQUEST'),

  /**
   *  추천 검색 키워드에 연결할 아이템 리스트 요청하기
   */
  GET_RECOMMEND_SEARCH_WORD_ITEM_REQUEST: 'recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_ITEM_REQUEST',
  GET_RECOMMEND_SEARCH_WORD_ITEM_SUCCESS: 'recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_ITEM_SUCCESS',
  getRecommendSearchWordItemList: createAction('recommend/searchWord/GET_RECOMMEND_SEARCH_WORD_ITEM_REQUEST'),

  /**
   *  추천 검색 키워드 등록/복사하기
   */
  CREATE_RECOMMEND_SEARCH_WORD_REQUEST: 'recommend/SEARCH_WORD/CREATE_RECOMMEND_SEARCH_WORD_REQUEST',
  createRecommendSearchWord: createAction('recommend/SEARCH_WORD/CREATE_RECOMMEND_SEARCH_WORD_REQUEST'),

  /**
   *  전체 검색 키워드 리스트 EXCEL 다운로드
   */
  GET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/SEARCH_WORD/GET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getRecommendSearchWordItemListExcelDownload: createAction(
    'recommend/SEARCH_WORD/GET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  선택된 검색 키워드 리스트 EXCEL 다운로드
   */
  GET_SELECTED_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/SEARCH_WORD/GET_SELECTED_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedRecommendSearchWordItemListExcelDownload: createAction(
    'recommend/SEARCH_WORD/GET_SELECTED_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  검색 키워드 리스트 EXCEL 업로드
   */
  SET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_UPLOAD_REQUEST:
    'recommend/SEARCH_WORD/SET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  SET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_UPLOAD_SUCCESS:
    'recommend/SEARCH_WORD/SET_RECOMMEND_SEARCH_WORD_ITEM_EXCEL_UPLOAD_SUCCESS',
  setRecommendSearchWordItemListExcelUpload: createAction(
    'recommend/SEARCH_WORD/SET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  ),
};

export default actions;
